<template>


  <div class="wrapper">
    <v-sidebar activeNavItem="shipment"></v-sidebar>

    <div class="main-panel">

      <v-navbar :title="'Shipment Details'" path="/shipment"></v-navbar>

      <div class="content">
        <h4 v-if="rfqErrorMessage" style="text-align: center">
          <font color="red">{{ rfqErrorMessage }}</font>
        </h4>
        <div v-if="!rfqErrorMessage">
          <div class="row" v-if="assetsLoaded && (assetsDispatched || isAwardedAssignee)">
            <div class="col-12">
              <div class="card bg-white mb-3">
                <div class="card-body">
                  <h4 class="card-title">
                    Dispatch
                  </h4>
                  <div class="form-group">
                    <label for="asset_tractor">Tractor</label>
                    <select id="asset_tractor" name="asset_tractor" class="form-control" v-bind:disabled="!assetsLoaded || assetsDispatched" v-model="dispatchedTractorId">
                      <option value=""></option>
                      <option v-for="tractor in tractors" v-bind:value="tractor._id">{{ tractor.title }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="asset_trailer">Trailer</label>
                    <select id="asset_trailer" name="asset_trailer" class="form-control" v-bind:disabled="!assetsLoaded || assetsDispatched" v-model="dispatchedTrailerId">
                      <option value=""></option>
                      <option v-for="trailer in trailers" v-bind:value="trailer._id">{{ trailer.title }}</option>
                    </select>
                  </div>

                  <p v-if="dispatchError" class="help is-danger">{{ dispatchError }}</p>

                  <button class="btn btn-success btn-wd" v-bind:disabled="assetsDispatched" v-on:click="dispatchAssetsHandler()"><i class="fa fa-road"></i> {{ assetsDispatched ? 'Dispatched' : 'Dispatch' }}</button>
                </div>
              </div>
            </div>
          </div>


          <div class="row" v-if="showDispatchSummary">
            <div class="col-12">
              <div class="card bg-white mb-3">
                <div class="card-body">
                  <h4 class="card-title">
                    Summary
                  </h4>
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <p><small class="text-muted">Requested Pick Up Date</small><br>{{ shipickupdate }}</p>

                      <div class="row">
                        <div class="col-6 col-md-3">
                          <p>
                            <small class="text-muted">Pick Up Date</small><br>{{ actualPickupTime }}
                            <template v-if="actualPickupTime && manualPickupTime"><br/>(set manually)</template>
                          </p>
                        </div>
                        <div class="col-6 col-md-3">
                          <button v-if="!actualPickupTime" class="btn btn-success btn-wd btn-sm" @click="showPickupDateModal">
                            <i class="fa fa-clock-o"></i> Set Pick Up Date
                          </button>
                        </div>
                      </div>
                      <p>
                        <small class="text-muted">Carbon Emission Total</small>
                        <br>
                        <span v-if="!carbonEmissionError && carbonEmissions > 0">{{ carbonEmissions }} kg of CO2</span>
                        <span v-if="carbonEmissionError" class="help is-danger">{{ carbonEmissionError }}</span>
                      </p>
                    </div>
                    <div class="col-12 col-sm-6">
                      <p><small class="text-muted">Requested Delivery</small><br>{{ condeliverydate }}</p>

                      <div class="row">
                        <div class="col-6 col-md-3">
                          <p>
                            <small class="text-muted">Delivery</small><br>{{ actualDeliveryTime }}
                            <template v-if="actualDeliveryTime && manualDeliveryTime"><br/>(set manually)</template>
                          </p>
                        </div>
                        <div class="col-6 col-md-3">
                          <button v-if="!actualDeliveryTime" class="btn btn-success btn-wd btn-sm" @click="showDeliveryDateModal"><i class="fa fa-clock-o"></i> Set Delivery Date</button>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row" v-if="showShipped && assetsDispatched">
                    <div class="col-sm-12">
                      <button v-on:click="shipped()" :disabled='loading' class="btn btn-success btn-wd"><i class="fa fa-truck"></i> Shipped</button>
                    </div>
                  </div>
                  <div class="row" v-if="!carbonEmissionError && carbonEmissions > 0">
                    <div class="col-12">
                      <p><small class="text-muted">Detailed Carbon Emission</small></p>
                      <ShippingLvls :readOnly=true :root="{ components: detailrows}" :showCarbon=true />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <UploadDocument
          :showGenerate=true
          :documents="documents"
          :rfq="rfq"
          :rfqId="rfqIdOnly"
          @fileUploaded="saveDocumentToRFQ"
          @deleteUploadedDocument="deleteDocument"
        />

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">RFQ Customer Details</h4>
                  <small class="text-muted">{{ rfqIdOnly }}</small>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-3 border-right">
                      <h5>Customer</h5>
                      <p><small class="text-muted">Company / Name</small><br>{{ cuscompany }}</p>
                      <p><small class="text-muted">Address</small><br>{{ cusaddress }}, {{cuscity}}, {{cusprovince}}<br>{{ cuspostal }}<br>{{cuscountry}}</p>
                      <p><small class="text-muted">Terms</small><br>{{ custerms }}</p>
                      <p><small class="text-muted">Due Date</small><br>{{ cusduedate }}</p>
                      <p><small class="text-muted">PO #</small><br>{{ cuspo }}</p>
                      <p><small class="text-muted">Sales #</small><br>{{ cussales }}</p>
                      <p><small class="text-muted">Transfer Order #</small><br>{{ custranferorder }}</p>
                    </div>
                    <div class="col-12 col-sm-3 border-right">
                      <h5>Shipper</h5>
                      <p><small class="text-muted">Company / Name</small><br>{{ shicompany }}</p>
                      <p><small class="text-muted">PO #</small><br>{{ shipo }}</p>
                      <p><small class="text-muted">Release #</small><br>{{ shirelease }}</p>
                      <p><small class="text-muted">Address</small><br>{{ shiaddress }}, {{ shicity }}, {{shiprovince}}<br>{{ shipostal }}<br>{{shicountry}}</p>

                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Appointment</small><br>{{ shiappointment }}</p></div>
                        <div class="col-6"><p><small class="text-muted">Liftgate</small><br>{{ shiliftgate }}</p></div>
                      </div>
                      <p><small class="text-muted">Requested Pick Up Date</small><br>{{ shipickupdate }}</p>

                    </div>
                    <div class="col-12 col-sm-3 border-right">
                      <h5>Consignee</h5>
                      <p><small class="text-muted">Company / Name</small><br>{{ conname }}</p>
                      <p><small class="text-muted">PO #</small><br>{{ conpo }}</p>
                      <p><small class="text-muted">Address</small><br>{{ conaddress }}, {{ concity }}, {{ conprovince }}<br>{{ conpostal }}<br>{{ concountry }}</p>
                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Appointment</small><br>{{ conappointment }}</p></div>
                        <div class="col-6"><p><small class="text-muted">Liftgate</small><br>{{ conliftgate }}</p></div>
                      </div>
                      <p><small class="text-muted">Requested Delivery</small><br>{{ condeliverydate }}</p>
                    </div>
                    <div class="col-12 col-sm-3">
                      <h5>Truck</h5>
                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Trailer Type</small><br>{{ trtrailertype }}</p></div>
                        <div class="col-6"><p><small class="text-muted">Suspension Type</small><br>{{ trsuspensiontype }}</p></div>
                      </div>
                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Temperature Control</small><br>{{ trtempcontrol }}</p></div>
                        <div class="col-6"><p><small class="text-muted">COD</small><br>{{ trcod }}</p></div>
                      </div>
                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Driver Assist</small><br>{{ trdriverassist }}</p></div>
                        <div class="col-6"><p><small class="text-muted">Mode</small><br>{{ trmode }}</p></div>
                      </div>
                      <div class="row">
                        <div class="col-6"><p><small class="text-muted">Service</small><br>{{ trservice }}</p></div>
                        <div class="col-6"><p><small class="text-muted">Dunnage Required</small><br>{{ trdunnagerequired }}</p></div>
                      </div>
                      <p><small class="text-muted">Special Instructions</small><br>{{ trspecialinstructions }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header">

              <div class="row">
                <div class="col-12">
                  <h4 class="card-title">Shipping Units</h4>
                </div>
              </div>

              </div>
              <div class="card-body">
                <div class="table-responsive">
                    
                    <table class="table table-borderless"> 
                        <thead>
                            <tr>
                                <th class="text-center squeeze"></th>
                                <th class="text-left" colspan="3" style="min-width: 320px; max-width: 320px;">Description / Lot</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Stackable</th>
                                <th class="text-center">Length {{suunitlength}}</th>
                                <th class="text-center">Width {{suunitlength}}</th>
                                <th class="text-center">Height {{suunitlength}}</th>
                                <th class="text-center">Weight {{suunitweight}}</th>
                                <th class="text-center">Hazard</th>
                                <th class="text-left" style="min-width: 120px; max-width: 120px;">Contents</th>
                                <th class="text-center squeeze"></th>
                            </tr>
                        </thead>
                        <tbody>
                        <template v-for="(row, shipIndex) in detailrows">
                          <TertiaryRow :key="'tertiary_'+shipIndex" :row="row" :shipIndex="shipIndex"
                          v-on:removeRow="null"
                          v-on:cloneRow="null"
                          :readOnly=true
                          />
                        </template>
                        </tbody>
                    </table>
                    
                </div>
              </div>
            </div>

          </div>
        </div>
        
        <ShippingSummary
          v-if="detailrows.length > 0"
          ref="summary"
          v-bind:rfq="rfq"
          v-bind:rows="detailrows"
          v-bind:density="density"
          v-bind:densityClass="densityclass"
          :totalWeight="totalWeight"
          :totalWeightKg="totalWeightKg"
        ></ShippingSummary>



          <div class="text-right">
            <a href="#/shipment/view" class="btn btn-success btn-wd"><i class="fa fa-chevron-left"></i> Back</a>
          </div>
        </div>
      </div>

      <v-footer></v-footer>

    </div>

    <v-pickup-date-modal/>
    <v-delivery-date-modal/>
  </div>


</template>

<script>
import apiService from '../../services/api.service'
import Vue from 'vue'
import modal from 'vue-strap/src/Modal'
import dispatchStatus from '../../constants/dispatchStatus'
import dateformat from 'dateformat'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import ShipmentPickUpDateModal from '../../components/ShipmentPickUpDateModal'
import ShipmentDeliveryDateModal from '../../components/ShipmentDeliveryDateModal';
import ShippingLvls from '../../components/shippinglvls/ShippingLvls'
import TertiaryRow from '../../components/shippinglvls/TertiaryRow.vue';
import UploadDocument from '../../components/UploadDocument'
import ShippingSummary from "../../components/ShippingSummary";

import { checkResponseErrors, fixError } from '../../utils/http'
import {LB_TO_KG} from '../../constants/weightConversion'

export default {
  name: 'ShipmentDetail',

  components: {
    'modal': modal,
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    'v-pickup-date-modal': ShipmentPickUpDateModal,
    'v-delivery-date-modal': ShipmentDeliveryDateModal,
    ShippingLvls,
    UploadDocument,
    TertiaryRow,
    ShippingSummary,
  },

  data: function () {
    return {
      rfq: null,
      rfqErrorMessage: '',

      rfqIdOnly: this.$route.params.id.split(".")[0],

      detailrows: [],
      status: '',
      level: '',
      cuscompany: '',
      cuspo: '',
      cussales: '',
      custranferorder: '',
      cusaddress: '',
      cuscity: '',
      cusprovince: '',
      cuscountry: '',
      cuspostal: '',
      cusentity: '',
      custerms: '',
      cusduedate: '',
      density: 'N/A',
      densityclass: 'N/A',
      totalWeight: 0,
      totalWeightKg: 0,
      shicompany: '',
      shipo: '',
      shirelease: '',
      shiaddress: '',
      shicity: '',
      shiprovince: '',
      shicountry: '',
      shipostal: '',
      shiliftgate: '',
      shipickupdate: '',
      shiappointment: '',
      conname: '',
      conpo: '',
      conaddress: '',
      concity: '',
      conprovince: '',
      conpostal: '',
      concountry: '',
      conentity: '',
      condeliverydate: '',
      conappointment: '',
      conliftgate: '',
      trtrailertype: '',
      trsuspensiontype: '',
      trtempcontrol: '',
      trcod: '',
      trdriverassist: '',
      trmode: '',
      trservice: '',
      trdunnagerequired: '',
      trspecialinstructions: '',
      documents: [],

      isAwardedAssignee: false,
      assetsDispatched: false,
      assetsLoaded: false,
      assets: {},
      tractors: [],
      trailers: [],
      dispatchedTractorId: '',
      dispatchedTrailerId: '',
      dispatchStatus: dispatchStatus.PENDING,
      actualPickupTime: '',
      actualDeliveryTime: '',
      manualPickupTime: false,
      manualDeliveryTime: false,
      carbonEmissions: 0,
      carbonEmissionError: '',
      dispatchError: '',
      shippingDimensionUnits: 'in/lbs',
    }
  },
  computed: {
    showDispatchSummary() {
      const s = dispatchStatus;
      return Object.values(s).includes(this.dispatchStatus);
    },
    showShipped() {
      const s = dispatchStatus;
      // Don't show if current dispatchStatus is shipped or stages after this
      return ![s.SHIPPED, s.DELIVERED].includes(this.dispatchStatus);
    },
    suunitlength: function() {
      const [lengthUnits, weightUnits] = this.shippingDimensionUnits.split('/');
      return `(${lengthUnits})`;
    },
    suunitweight: function() {
      const [lengthUnits, weightUnits] = this.shippingDimensionUnits.split('/');
      return `(${weightUnits})`;
    },
  },
  async mounted() {
    //always refresh after viewing this page to update the bold unread rows on the dashboard
    sessionStorage.refresh = "true";

    const vm = this

    // Get the RFQ Details
    await apiService.get('/kong/api/v1/rfq/id/', {
      headers: { 'X-Raefton-RFQ-ID': this.$route.params.id }
    }).then((response) => {
      var rel = response.data.Result
      vm.rfq = rel;
      vm.status = rel.status

      // console.log(JSON.stringify(rel, null, 2))
      localStorage["lastViewedDate"+this.rfqIdOnly+localStorage.getItem('local_id')] = new Date().toISOString();

      vm.level = rel.securitylevel
      vm.cuscompany = rel.customer.name + ", " + rel.customer.company
      vm.cuspo = rel.customer.po
      vm.cussales = rel.customer.sales
      vm.custranferorder = rel.customer.transferOrder
      vm.cusentity = rel.customer.entity
      vm.cusaddress = rel.customer.address

      vm.cuscity = rel.customer.city
      vm.cusprovince = rel.customer.province
      vm.cuscountry = rel.customer.country

      vm.cuspostal = rel.customer.postal

      vm.custerms = rel.customer.terms
      vm.cusduedate = safeDate(rel.customer.duedate, rel.customer.dueDateTime);

      vm.shicompany = rel.shipper.name + ", " + rel.shipper.company
      vm.shipo = rel.shipper.po
      vm.shirelease = rel.shipper.release
      vm.shiaddress = rel.shipper.address
      vm.shicity = rel.shipper.city
      vm.shiprovince = rel.shipper.province
      vm.shicountry = rel.shipper.country

      vm.shipostal = rel.shipper.postal

      vm.shiliftgate = rel.shipper.liftgate;
      if (vm.shiliftgate == null || vm.shiliftgate == "") vm.shiliftgate = rel.truck.liftgate;

      vm.shipickupdate = safeDate(rel.shipper.pickupdate, rel.shipper.pickupDateTime);

      vm.shiappointment = rel.shipper.appointment == true ? "Yes" : "No"
      vm.conname = rel.consignee.name + ", " + rel.consignee.company
      vm.conpo = rel.consignee.po
      vm.conaddress = rel.consignee.address
      vm.concity = rel.consignee.city
      vm.conprovince = rel.consignee.province
      vm.concountry = rel.consignee.country
      vm.conentity = rel.consignee.entity
      vm.conpostal = rel.consignee.postal
      vm.condeliverydate = safeDate(rel.consignee.deliverydate, rel.consignee.deliveryDateTime)
      vm.conappointment = rel.consignee.appointment == true ? "Yes" : "No"

      vm.conliftgate = rel.consignee.liftgate;
      if (vm.conliftgate == null || vm.conliftgate == "") vm.conliftgate = rel.truck.liftgate;


      vm.density = rel.density
      vm.densityclass = rel.densityclass

      // Shipping Unit Stuff

      if (rel.shippingunit != null && rel.shippingunit.length > 0) {
        // Get a list of all current shipping units
        var rowslen = vm.detailrows.length
        for (var m = 0; m < rowslen; m++) {
          vm.detailrows.pop()
        }
        let totalWeight = 0;
        let totalWeightKg = 0;
        for (var q = 0; q < rel.shippingunit.length; q++) {
          const relSu = rel.shippingunit[q];
          // Push cargo
          var suCargo = []
          if (relSu.cargo != null && relSu.cargo.length > 0) {
            for (var w = 0; w < relSu.cargo.length; w++) {
              var quantity = relSu.cargo[w].quantity;
              if (quantity == null || quantity.length == 0) quantity = "N/A";
              suCargo.push({cargonumber: w + 1, cargodescription: relSu.cargo[w].cargo, cargoquantity: quantity, hazardousgoods: relSu.cargo[w].hazardousgoods, packinginstructions: relSu.cargo[w].packinginstructions, cargoclass: relSu.cargo[w].class, hsclassification: relSu.cargo[w].hsclassification, unnumber: relSu.cargo[w].unnumber})
            }
          }

          const itemWeight = relSu.weight;
          const itemQuantity = relSu.quantity;
          this.shippingDimensionUnits = relSu.unitsofmeasure;
          if(relSu.unitsofmeasure.includes('kgs')) {
            totalWeight += ((itemWeight / LB_TO_KG) * itemQuantity);
            totalWeightKg += (itemWeight * itemQuantity);
          } else if(relSu.unitsofmeasure.includes('lbs')) {
            totalWeight += (itemWeight * itemQuantity)
            totalWeightKg += ((itemWeight * LB_TO_KG) * itemQuantity)
          }
          vm.detailrows.push({number: q + 1,
            description: relSu.description,
            type: relSu.type,
            quantity: relSu.quantity,
            length: relSu.length,
            width: relSu.width,
            height: relSu.height,
            weight: relSu.weight,
            stackable: relSu.stackable,
            unitsofmeasure: relSu.unitsofmeasure,
            carbonEmissionPerUnit: relSu.carbonEmissionPerUnit,
            components: relSu.components,
            hazardous: relSu.hazardous || 'No',
          })
        }
        vm.totalWeight = Math.round(totalWeight*10)/10;
        vm.totalWeightKg = Math.round(totalWeightKg*10)/10;
      }
      vm.trtrailertype = rel.truck.trailertype
      vm.trsuspensiontype = rel.truck.suspensiontype
      vm.trtempcontrol = rel.truck.tempcontrol

      vm.trcod = rel.truck.cod;
      if (vm.trcod == null) vm.trcod = rel.consignee.cod;
      vm.trcod = vm.trcod == true ? "Yes" : "No"

      vm.trdriverassist = rel.truck.driverassist
      vm.trmode = rel.truck.mode
      vm.trservice = rel.truck.service
      vm.trdunnagerequired = rel.truck.dunnagerequired
      vm.trspecialinstructions = rel.truck.specialinstructions

      vm.isAwardedAssignee = rel.awarded;
      vm.documents = rel.documents;

      console.log(rel);

      const dispatch = rel.dispatch;
      if(dispatch) {
        vm.assetsDispatched = true;
        vm.dispatchedTractorId = dispatch.tractorId;
        vm.dispatchedTrailerId = dispatch.trailerId;
        vm.dispatchStatus = rel.dispatchStatus;
        vm.manualPickupTime = dispatch.manualPickupTime;
        vm.manualDeliveryTime = dispatch.manualDeliveryTime;

        vm.actualPickupTime = safeDate(null, dispatch.actualPickupTime);
        vm.actualDeliveryTime = safeDate(null, dispatch.actualDeliveryTime);
        if(typeof dispatch.carbonEmissions === "number" && dispatch.carbonEmissions > 0) {
          vm.carbonEmissions = +dispatch.carbonEmissions.toFixed(4);
        }
        vm.carbonEmissionError = dispatch.carbonEmissionError;
      }

      // can only dispatch under certain conditions
      vm.checkForReadOnly(vm, rel);

      console.log("---- I am " + localStorage.getItem('local_id'));

    }).catch(function (error) {
      vm.rfqErrorMessage = error.response.data.Result
    });

    if(this.rfqErrorMessage) return;

    if(!this.isAwardedAssignee && !this.assetsDispatched) return;

    // Load Assets
    if(!this.assetsDispatched) {
      await this.fetchAllAssets();
    } else {
      await this.fetchDispatchedAssets();
    }

    // set date events
    this.$on('pickupDateSet', (props) => {
      this.actualPickupTime = dateformat(props.date, "yyyy-mm-dd HH:MM");
      this.manualPickupTime = true;
      sessionStorage.refreshAwarded = "true";
    });
    this.$on('deliveryDateSet', (props) => {
      this.actualDeliveryTime = dateformat(props.date, "yyyy-mm-dd HH:MM");
      this.manualDeliveryTime = true;
      sessionStorage.refreshAwarded = "true";
    });
  },
  methods: {
    checkForReadOnly(vm, rel) {
      // Check if status is open or assigned
      if (rel.status !== 'Open' && rel.status !== 'Assigned' && rel.status !== 'Customer Review') {
        vm.setRFQReadOnly();
      }

      //don't allow a Customer to edit anything about the RFQ
      if (vm.level === 'Customer') {
        vm.setRFQReadOnly();
      }

      if (vm.level !== 'Creator') {
        //don't allow editing during Customer Review by anyone except owner
        if (vm.status === 'Customer Review') {
          vm.setRFQReadOnly();
        }
      }
    },

    setRFQReadOnly() {
      console.log("this RFQ is read only");
    },

    fetchAllAssets: async function() {
      try {
        const resp = await apiService.get('/asset/list');
        if(await checkResponseErrors(resp)) return;

        const body = resp.data;
        if(body.Result && body.Result.length >= 0) this.buildAssetLists(body.Result);
      } catch (error) {
        Vue.toasted.error(error, { duration: 3500 });
      }
    },

    buildAssetLists(fetchedAssets) {
      fetchedAssets.forEach(asset => {
        asset.title = `${asset.make} - ${asset.model}`;
        if(asset.assetId) asset.title += ` - ${asset.assetId}`;

        if(asset.type === "Tractor") {
          this.tractors.push(asset);
        } else {
          this.trailers.push(asset);
        }

        this.assets[asset._id] = asset;
      });

      this.assetsLoaded = true;
    },

    async dispatchAssetsHandler() {
      if(this.assetsDispatched) return;
      this.assetsDispatched = true;

      if(!this.isDispatchValid()) {
        this.assetsDispatched = false;
        return;
      }

      const tractor = this.assets[this.dispatchedTractorId];
      const trailer = this.assets[this.dispatchedTrailerId];

      let msg;
      if(trailer) {
        msg = `Are you sure you want to dispatch the tractor "${tractor.title}" with the trailer "${trailer.title}"?`;
      } else {
        msg = `Are you sure you want to dispatch the straight truck "${tractor.title}"?`;
      }

      if(!confirm(msg)) {
        this.assetsDispatched = false;
        return;
      };

      // dispatch
      this.assetsDispatched = await this.dispatchAssets();
    },

    async dispatchAssets() {
      sessionStorage.refreshAwarded = "true";
      try {
        const response = await apiService.post('/kong/api/v1/shipment/dispatch/', {
          tractorId: this.dispatchedTractorId,
          trailerId: this.dispatchedTrailerId,
        }, {
          headers:{
            'X-Raefton-RFQ-ID': this.rfqIdOnly
          }
        });

        if(await checkResponseErrors(response)){
          return false;
        };
      } catch (error) {
        const errorMsg = fixError(error);
        console.log(errorMsg);
        Vue.toasted.error(errorMsg, { duration: 5000 });
        return false;
      }

      return true;
    },

    isDispatchValid() {
      this.dispatchError = '';

      if(!this.dispatchedTractorId) {
        this.dispatchError = 'A tractor is required to dispatch.';
      }
      else if(!this.dispatchedTrailerId && this.assets[this.dispatchedTractorId].tractorType !== "StraightTruck") {
        this.dispatchError = 'A trailer or straight truck is required to dispatch.';
      } else if(this.dispatchedTrailerId && this.assets[this.dispatchedTractorId].tractorType === "StraightTruck") {
        this.dispatchError = 'A straight truck cannot have a separate trailer.';
      }

      return !this.dispatchError;
    },

    shipped: async function() {
      console.log('Shipped');
      try {
        if (this.assetsDispatched) {
          const timeNow = new Date();
          const rfqId = this.$route.params.id.split(".")[0];
          if(!rfqId) return console.log('Unable to set rfq to shipped. Missing Ids');
          const response = await apiService.post(`/rfq/${rfqId}/changeDispatchStatus/`, {
            pickupTime: new Date().getTime()
          });
          if (response.status === 200) {
            Vue.toasted.success("Successfully Shipped", { duration: 3500 })
            this.dispatchStatus = dispatchStatus.SHIPPED;
            this.shipickupdate = safeDate(timeNow, timeNow.getTime());
            
          }
        } else {
          throw new Error('Please dispatch first');
        }
      } catch (error) {
        Vue.toasted.error(error.message, { duration: 3500 });
      }
    },

    fetchDispatchedAssets: async function () {
      const assets = [];

      const fetchAsset = async (id) => {
        try {
          const resp = await apiService.get('/kong/api/v1/asset/basic/' + id);
          if(await checkResponseErrors(resp)) return;

          const body = resp.data
          if(body.Result) assets.push(body.Result);
        } catch (error) {
          Vue.toasted.error(error, { duration: 3500 });
        }
      }

      if(this.dispatchedTractorId) await fetchAsset(this.dispatchedTractorId);
      if(this.dispatchedTrailerId) await fetchAsset(this.dispatchedTrailerId);
      this.buildAssetLists(assets);
    },

    showPickupDateModal() {
      const rfqId = this.$route.params.id.split(".")[0];
      this.$modal.show("shipment-pickup-date", { rfqId });
    },

    showDeliveryDateModal() {
      const rfqId = this.$route.params.id.split(".")[0];
      this.$modal.show("shipment-delivery-date", { rfqId });
    },
    saveDocumentToRFQ: async function (fileData) {
      const response = await apiService.post(`/rfq/${this.rfqIdOnly}/document`, {fileData: fileData})
      this.documents = response.data;
    },
    deleteDocument: async function({rfqId, docId}) {
      if(!rfqId || !docId) return console.log('Unable to delete document. Missing Ids')
      const response = await apiService.delete(`/rfq/${rfqId}/document/${docId}`)
      this.documents = response.data;
    }
  }
}

</script>



// WEBPACK FOOTER //
// ShipmentDetail.vue?0af45b36